import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiUsers } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { useSession } from '@/hooks/useSession';
import { PlayfulCard, PlayfulCardButton } from '@/components/custom/playful-card';
import projetosIcon from '@/assets/images/icons/projetos.png';

export function ProjectsPlayfulCard({ data }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { session } = useSession();

  const isParticipant = data['project-users']?.some(projectUser => projectUser.user_id === session.user.id);
  const projectUrl = isParticipant ? `/projetos/${data.id}` : `/projetos/${data.id}/sobre`;
  const buttonText = isParticipant ? t('button.accessProject') : t('button.detailsProject');

  return (
    <PlayfulCard
      badge={{
        text: data.approved ? t('exams.statusInApproved') : t('exams.inProgress'),
        variant: 'amber-soft',
        className: 'rounded-full px-2.5 py-1 text-xs font-bold normal-case'
      }}
      className="p-6"
      onClick={() => navigate(projectUrl)}
    >
      <img
        src={projetosIcon}
        alt=""
        aria-hidden="true"
        className="h-20 w-20 object-contain drop-shadow-sm"
      />
      <h3
        className="mb-0 mt-3 line-clamp-3 text-base font-extrabold"
        style={{ color: '#222731' }}
      >
        {data.name}
      </h3>

      <div className="mt-auto flex flex-col gap-3 pt-2">
        <span className="flex items-center gap-1.5 text-xs font-semibold text-neutral-dark">
          <FiUsers className="h-3.5 w-3.5 text-[var(--color-mission-medium)]" />
          {data?.users?.length ?? 0} {t('projects.participants')}
        </span>

        <PlayfulCardButton
          onClick={() => navigate(projectUrl)}
          className="py-3"
        >
          {buttonText}
        </PlayfulCardButton>
      </div>
    </PlayfulCard>
  );
}
